const getParameterByName = (name, url) => {
    name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
    const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    const results = regex.exec(url || window.location.href);
    return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, " "));
  };


export const oidcConfig = {
    authority: "https://id.zipalong.tech", // The authority URL (Issuer)
    clientId: "webbieshop-wt", // Your client ID
    redirectUri: "https://mclardies.webbieshop.com/login/callback",
    silent_redirect_uri: "https://mclardies.webbieshop.com/silent-renew",
    post_logout_redirect_uri: "https://mclardies.webbieshop.com",
    responseType: "code",
    scope: "openid profile",
    response_mode: "fragment",
    automaticSilentRenew: true,
    loadUserInfo: false,
    pkce: true,
    extraQueryParams: {acr_values:`token_nonce:${getParameterByName("token_nonce")}`}
};
export const initialOidcConfigSyringa   = {
    authority: "https://id.zipalong.tech", // The authority URL (Issuer)
    clientId: "webbieshop-wt", // Your client ID
    redirectUri: "https://broadacressyringa.webbieshop.com/login/callback",
    silent_redirect_uri: "https://broadacressyringa.webbieshop.com/silent-renew",
    post_logout_redirect_uri: "https://broadacressyringa.webbieshop.com",
    responseType: "code",
    scope: "openid profile",
    response_mode: "fragment",
    automaticSilentRenew: true,
    loadUserInfo: false,
    pkce: true,
    extraQueryParams: {acr_values:`token_nonce:${getParameterByName("token_nonce")}`}
};
export const  initialOidcConfigChartwell = {
    authority: "https://id.zipalong.tech", // The authority URL (Issuer)
    clientId: "webbieshop-wt", // Your client ID
    redirectUri: "https://broadacreschartwell.webbieshop.com/login/callback",
    silent_redirect_uri: "https://broadacreschartwell.webbieshop.com/silent-renew",
    post_logout_redirect_uri: "https://broadacreschartwell.webbieshop.com",
    responseType: "code",
    scope: "openid profile",
    response_mode: "fragment",
    automaticSilentRenew: true,
    loadUserInfo: false,
    pkce: true,
    extraQueryParams: {acr_values:`token_nonce:${getParameterByName("token_nonce")}`}
};
export const  initialOidcConfigQIAshop = {
    authority: "https://id.zipalong.tech", // The authority URL (Issuer)
    clientId: "webbieshop-wt", // Your client ID
    redirectUri: "https://qiatuckshop.webbieshop.com/login/callback",
    silent_redirect_uri: "https://qiatuckshop.webbieshop.com/silent-renew",
    post_logout_redirect_uri: "https://qiatuckshop.webbieshop.com",
    responseType: "code",
    scope: "openid profile",
    response_mode: "fragment",
    automaticSilentRenew: true,
    loadUserInfo: false,
    pkce: true,
    extraQueryParams: {acr_values:`token_nonce:${getParameterByName("token_nonce")}`}
};

export const oidcConfigBeta = {
    authority: "https://id.zipalong.tech", // The authority URL (Issuer)
    clientId: "webbieshop-wt", // Your client ID
    redirectUri: "https://d6auth.vercel.app/login/callback",
    silent_redirect_uri: "https://d6auth.vercel.app/silent-renew",
    post_logout_redirect_uri: "https://d6auth.vercel.app",
    responseType: "code",
    scope: "openid profile",
    response_mode: "fragment",
    automaticSilentRenew: true,
    loadUserInfo: false,
    pkce: true,
    extraQueryParams: {acr_values:`token_nonce:${getParameterByName("token_nonce")}`}
};

// export const oidcConfig = {
//     authority: "https://id.zipalong.tech", // The authority URL (Issuer)
//     clientId: "webbieshop-wt", // Your client ID
//     redirectUri: "https://d6auth.vercel.app//login/callback",
//     silent_redirect_uri: "https://d6auth.vercel.app//silent-renew",
//     post_logout_redirect_uri: "https://d6auth.vercel.app/",
//     responseType: "code",
//     scope: "openid profile",
//     response_mode: "fragment",
//     automaticSilentRenew: true,
//     loadUserInfo: false,
//     pkce: true
// };
  